{
	"title": "Utwórz deklarację",
	"backLinkToMaterialDetailsTitle": "Wróć do szczegółów materiału",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Wróć do {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Wróć do: Zarządzaj deklaracjami",
	"steps": {
		"firstStep": {
			"title": "Krok 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Krok 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Krok 3",
			"label": "3"
		}
	}
}
